const numberNoti = (payload) => {
  return {
    type: "noticount",
    payload,
  };
};

export default numberNoti;
